import { useState } from "react";
import { useForm } from "react-hook-form";
import toast from "react-hot-toast";

import { yupResolver } from "@hookform/resolvers/yup";
import { updateEmailVerification } from "../../../service";
import { theme } from "../../../../theme";
import BtnSpinner from "../../../../common/BtnSpinner";
import emailUpdateSchema from "../../../schema/emailUpdate";
import { TextField } from "@mui/material";
import { removeEmailOtpResendCount } from "../../../../storage/emailOtpResendCount";

const EmailAddressSubmit = ({ftm_id, handleCloseEdit, newDetails, setNewDetails}) => {
    const {
        register,
        handleSubmit,
        reset,
        formState: { errors },
    } = useForm({
        resolver: yupResolver(emailUpdateSchema),
    });

    const [isLoading, setIsLoading] = useState(false);

    const onSubmitEmail = async ({ ftm_email }) => {
        try {
            setIsLoading(true);
            const response = await updateEmailVerification(ftm_id, ftm_email);
            if (response.status === 'Success') {
                setIsLoading(false);
                handleCloseEdit();
                setNewDetails({ ...newDetails, email: ftm_email });

                removeEmailOtpResendCount();
            } else {
                toast.error(response.message);
            }
        } catch (error) {
            console.error('Error submitting email:', error);
        } finally {
            reset();
            setIsLoading(false);
        }
    };

    return (
        <form
            onSubmit={handleSubmit(onSubmitEmail)}
            className="m-2"
        >
            <div className="row gx-2 gx-sm-3 mb-3">
                <h5 className="mb-1 text-gradient text-dark">
                    PLEASE ENTER YOUR VALID EMAIL ADDRESS
                </h5>
                <p className="mb-2 text-sm">
                    Please enter your valid email address to receive a new verification code.
                </p>
                <div className="col-12 col-md-12 mt-3">
                    <TextField
                        type="text"
                        placeholder="Email"
                        size="small"
                        {...register('ftm_email')}
                        fullWidth
                        error={!!errors?.ftm_email}
                        helperText={errors?.ftm_email?.message}
                    />
                </div>
            </div>

            <div className="d-flex justify-content-center gap-2">
                <button
                    type="submit"
                    className={`btn btn-sm bg-gradient-${theme.main} w-100 my-4 mb-0`}
                    disabled={isLoading}
                >
                    {isLoading ? <BtnSpinner /> : 'SUBMIT'}
                </button>
                <button
                    className={`btn btn-sm bg-gradient-${theme.close_btn} w-100 my-4 mb-0`}
                    onClick={handleCloseEdit}
                    disabled={isLoading}
                >
                    {isLoading ? <BtnSpinner /> : 'CLOSE'}
                </button>
            </div>
        </form>
    );
};

export default EmailAddressSubmit;